"use strict";
exports.__esModule = true;
exports.GdcVisualizationWidget = void 0;
var tslib_1 = require("tslib");
// (C) 2020-2021 GoodData Corporation
var isEmpty_1 = tslib_1.__importDefault(require("lodash/fp/isEmpty"));
var has_1 = tslib_1.__importDefault(require("lodash/has"));
/**
 * @public
 */
var GdcVisualizationWidget;
(function (GdcVisualizationWidget) {
    function isDrillToVisualization(obj) {
        return !isEmpty_1["default"](obj) && !!obj.drillToVisualization;
    }
    GdcVisualizationWidget.isDrillToVisualization = isDrillToVisualization;
    function isDrillToDashboard(obj) {
        return !isEmpty_1["default"](obj) && !!obj.drillToDashboard;
    }
    GdcVisualizationWidget.isDrillToDashboard = isDrillToDashboard;
    function isDrillToCustomUrl(obj) {
        return !isEmpty_1["default"](obj) && !!obj.drillToCustomUrl;
    }
    GdcVisualizationWidget.isDrillToCustomUrl = isDrillToCustomUrl;
    function isDrillToAttributeUrl(obj) {
        return !isEmpty_1["default"](obj) && !!obj.drillToAttributeUrl;
    }
    GdcVisualizationWidget.isDrillToAttributeUrl = isDrillToAttributeUrl;
    function isDrillFromMeasure(obj) {
        return !isEmpty_1["default"](obj) && !!obj.drillFromMeasure;
    }
    GdcVisualizationWidget.isDrillFromMeasure = isDrillFromMeasure;
    function isDrillFromAttribute(obj) {
        return !isEmpty_1["default"](obj) && !!obj.drillFromAttribute;
    }
    GdcVisualizationWidget.isDrillFromAttribute = isDrillFromAttribute;
    function isVisualizationWidget(obj) {
        return !isEmpty_1["default"](obj) && obj.meta.category === "visualizationWidget";
    }
    GdcVisualizationWidget.isVisualizationWidget = isVisualizationWidget;
    function isWrappedVisualizationWidget(obj) {
        // eslint-disable-next-line no-prototype-builtins
        return !isEmpty_1["default"](obj) && has_1["default"](obj, "visualizationWidget");
    }
    GdcVisualizationWidget.isWrappedVisualizationWidget = isWrappedVisualizationWidget;
})(GdcVisualizationWidget = exports.GdcVisualizationWidget || (exports.GdcVisualizationWidget = {}));
//# sourceMappingURL=GdcVisualizationWidget.js.map